import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Text from "@mui/material/Typography";
import SearchImage from "../../assets/images/Search.png";
import AdvancedSearchImage from "../../assets/images/AdvanceSearch.png";
import { useAppSelector } from "../../store/hooks";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { keyframes, Modal, Typography } from "@mui/material";
import WelcomePage from "./WelcomePage";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { useEffect, useState } from "react";
interface PropType {
  isAdvanceSearch?: boolean;
  modalIsOpen?: any;
  handleCloseModal?: any;
  handleWelcomeClick1?: any;
  animationGreeting?: any;
  notifications?: any;
}
const HeaderSection = (props: PropType) => {
  const customer_details = useAppSelector(
    (state) => state?.customer?.customerDetails
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const {
    isAdvanceSearch,
    modalIsOpen,
    handleCloseModal,
    handleWelcomeClick1,
    animationGreeting,
    notifications,
  } = props;

  const animationGreeting1 = keyframes`
    0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
   `;

  // Extend dayjs with required plugins (do this once, preferably at app entry)
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(isSameOrAfter);

  // Fallback expiry datetime
  const expiryDateTime = notifications?.[0]?.dateto || "31-05-2025 11:00";
  const message = notifications?.[0]?.notificationmessage ?? "";
  // Split message into sentences
  const sentences = message
    .split(".")
    .map((word: string) => word.trim())
    .filter(Boolean);

  // Extract headline and date part
  const [headlinePart, datePart] = sentences[0]?.split(",") ?? [];
  const [isExpired, setIsExpired] = useState(false);

  const part1 = headlinePart ? `${headlinePart},` : "";
  const part2 = datePart?.trim() ?? "";
  const part3 = sentences.slice(1).join(". ");

  // Define IST timezone
  const IST = "Asia/Kolkata";

  // useEffect(() => {
  //   const targetTime = dayjs.tz(expiryDateTime, "DD-MM-YYYY HH:mm", IST);
  //   const checkTimeAndRefresh = () => {
  //     const nowIST = dayjs().utc().tz(IST);

  //     if (nowIST.isSameOrAfter(targetTime)) {
  //       clearInterval(interval); // ❌ Stop checking
  //       //   window.location.reload(); // 🔁 Refresh page once
  //     }
  //   };
  //   const interval = setInterval(checkTimeAndRefresh, 10000); // Check every 10 seconds
  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, []);

  useEffect(() => {
    if (!expiryDateTime) return;

    const targetTime = dayjs.tz(expiryDateTime, "DD-MM-YYYY HH:mm", IST);

    const checkTimeAndRefresh = () => {
      const nowIST = dayjs().tz(IST);
      setIsExpired(nowIST.isSameOrAfter(targetTime));
    };
    // Calculate exact milliseconds to target
    const now = dayjs().utc().tz(IST);
    const diff = targetTime.diff(now);

    //  Check immediately
    checkTimeAndRefresh();

    // Check when tab becomes active
    window.addEventListener("focus", checkTimeAndRefresh);
    document.addEventListener("visibilitychange", checkTimeAndRefresh);

    const interval = setInterval(checkTimeAndRefresh, 10000); // every 10 sec
    return () => {
      window.removeEventListener("focus", checkTimeAndRefresh);
      document.removeEventListener("visibilitychange", checkTimeAndRefresh);
      clearInterval(interval);
    };
  }, [expiryDateTime]);

  // const disableScrollBarondate = () => {
  //   // 1. Get current UTC time
  //   const nowUTC = dayjs.utc();

  //   // 2. Convert UTC to IST
  //   const nowIST = nowUTC.tz(IST);

  //   // 3. Define the target IST datetime (30 May 2025, 11:00 AM IST)
  //   // change the date and time here
  //   const targetIST = dayjs.tz(expiryDateTime, "DD-MM-YYYY HH:mm", IST);

  //   // 4. Compare: is current IST time on or after target?
  //   const isNowOrAfterTargetIST = nowIST.isSameOrAfter(targetIST);
  //   return isNowOrAfterTargetIST;
  // };

  const disableScrollBarondate = () => {
    if (!expiryDateTime) return false;

    const nowIST = dayjs().tz(IST);
    const targetIST = dayjs.tz(expiryDateTime, "DD-MM-YYYY HH:mm", IST);

    return nowIST.isSameOrAfter(targetIST);
  };

  return (
    <Stack
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      direction={"row"}
      className="image-parent-container"
    >
      {/* {isBanner && ( */}
      {
        //  isMobile?<div style={{
        //   position:"absolute",
        //   width:"100%",
        //   top:"30px",
        //     zIndex:1}}>

        //           <Box
        //             sx={{
        //               borderBottom: "1px solid black",
        //               borderTop: "1px solid black",
        //               backgroundColor: "#7852fb",
        //               // overflow: "hidden",
        //             }}
        //           >
        //             {/* <Modal
        //               open={modalIsOpen}
        //               onClose={handleCloseModal}
        //               sx={{
        //                // height: "fit-content",
        //                 width: "90%",
        //                 // overflow: "hidden",
        //                 margin: "0 auto",
        //                 marginTop: "10px",
        //                 borderRadius: "10px",
        //               }}
        //             >
        //               <WelcomePage handleClose={handleCloseModal} />
        //             </Modal> */}
        //             <Typography
        //               onClick={handleWelcomeClick1}
        //               // variant="h6"
        //               fontSize="8.5px"
        //               fontFamily={"Helvetica Neue"}
        //               fontWeight={"600"}
        //               sx={{
        //                 cursor: "pointer",
        //                 textDecoration: "underline",
        //                 color: "white",
        //                 textAlign: "center",
        //                 animationName: `${animationGreeting}`,
        //                 animationDuration: "15s",
        //                 animationTimingFunction: "linear",
        //                 animationIterationCount: "infinite",
        //               }}
        //             >
        //              May 2025 J-Gate User Training FREE National Webinar. Click Here to Register.
        //             </Typography>
        //           </Box>
        //          </div>
        //  :
        // !disableScrollBarondate() && (
        !isExpired && (
          <Box
            sx={{
              position: "absolute",
              width: { xs: "20%", sm: "20%" },
              top: { xs: "20px", lg: "30px" },
              right: "42px",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                backgroundColor: "#7852fb",

                padding: { xs: "2px", sm: "6px", lg: "10px" },

                overflow: "visible",
              }}
            >
              {/* <Modal
                    open={modalIsOpen}
                    onClose={handleCloseModal}
                    sx={{
                    //  height: "fit-content",
                      width: "90%",
                    // overflow: "hidden",
                    //  margin: "0 auto",
                      marginTop: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <WelcomePage handleClose={handleCloseModal} />
                  </Modal> */}
              <Typography
                onClick={handleWelcomeClick1}
                variant={"h5"}
                fontFamily={"Helvetica Neue"}
                fontSize={{ xs: "8px", sm: "10px", lg: "15px" }}
                fontWeight={"600"}
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "white",
                  textAlign: "center",
                  animationName: `${animationGreeting1}`,
                  animationDuration: "3s",
                  animationTimingFunction: "linear",
                  animationIterationCount: "infinite",
                }}
              >
                {/* May 2025 J-Gate User Training */}
                {part1}
                <Typography
                  variant={"h5"}
                  fontFamily={"Helvetica Neue"}
                  fontSize={{ xs: "8px", sm: "10px", lg: "15px" }}
                  fontWeight={"600"}
                >
                  {/* FREE National Webinar. */}
                  {part2}
                </Typography>
                <Typography
                  variant={"h5"}
                  fontFamily={"Helvetica Neue"}
                  fontSize={{ xs: "8px", sm: "10px", lg: "15px" }}
                  fontWeight={"600"}
                >
                  {/* {" "}
                  Click Here to Register. */}
                  {part3}
                </Typography>
              </Typography>
            </Box>
          </Box>
        )
      }
      {/* )} */}
      <img
        src={isAdvanceSearch ? AdvancedSearchImage : SearchImage}
        alt="Search"
        className="basicsearch-image"
      />

      {!isAdvanceSearch && customer_details?.product_package && (
        <div className="product-package-details">
          {isMobile
            ? customer_details?.product_package
            : customer_details.product_package.split(",").map((pkg, index) => (
                <Text sx={{ fontSize: "18px" }} key={index}>
                  {pkg.trim()}
                </Text>
              ))}
        </div>
      )}

      <Box className="gradient-overlay" />
    </Stack>
  );
};

export default HeaderSection;
